"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionDetails = void 0;
const validation_1 = require("../../validation");
const notifications_1 = require("./notifications");
// Define the schema for NotificationChannelType
const NotificationChannelTypeSchema = {
    type: 'object',
    required: ['email', 'in_app'],
    properties: {
        email: {
            type: 'boolean'
        },
        in_app: {
            type: 'boolean'
        }
    }
};
const messageTypeProperties = Object.values(notifications_1.NotificationType).reduce((properties, notificationType) => {
    properties[notificationType] = NotificationChannelTypeSchema;
    return properties;
}, {});
/**
 * Subscription details
 * @alpha
 */
var SubscriptionDetails;
(function (SubscriptionDetails) {
    SubscriptionDetails.schema = {
        type: 'object',
        required: ['ignore_all_email', 'ignore_all_in_app', 'message_type'],
        properties: {
            ignore_all_email: {
                type: 'boolean'
            },
            ignore_all_in_app: {
                type: 'boolean'
            },
            message_type: {
                type: 'object',
                required: Object.values(notifications_1.NotificationType),
                additionalProperties: false,
                properties: messageTypeProperties
            }
        }
    };
    SubscriptionDetails.validate = (0, validation_1.generateLazyValidator)(SubscriptionDetails.schema);
})(SubscriptionDetails = exports.SubscriptionDetails || (exports.SubscriptionDetails = {}));
//# sourceMappingURL=subscription-details.js.map